<template>
	<Btn class="tag">
		<span class="tag__label link--action fs--10">{{label}}</span>
		<span class="tag__close fonticon fonticon--close fs--7" @click="$emit('close')"></span>
	</Btn>
</template>

<script>
import Btn from '../atoms/Btn';

export default {
	name: 'Tag',
	components: {
		Btn,
	},
	props: {
		label: String,
	},
	computed: {
	},
	mounted: function() {
	},
	methods: {
	}
}
</script>

<style scoped lang="scss">

	@import "src/scss/toolkit";

	$c: ".tag";
	#{$c}
	{
		border-radius: 3px;
		padding-left: rem(12);
		padding-right: rem(12);

		&__label
		{
			font-size: 10px;
			@include extend(link--action);
		}

		&__close
		{
			font-size: 7px;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/atoms/Tag.vue